import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionCleanupService } from 'src/app/services/session-cleanup.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isLoggingOut = false;

  // Public feedback endpoints should not force-login on 401.
  private readonly publicFeedbackPaths = [
    '/qac/execution/get_feedback_projectid_using_token',
    '/qac/execution/get_feedback_list_json',
    '/qac/execution/postfeedback',
    '/qac/execution/feedback_category_for_lov',
    '/qac/execution/get_activity_feedback_points_public'
  ];

  // Optional background integrations should not hard-logout the whole app
  // when a client base URI does not support or authorize them.
  private readonly nonBlockingUnauthorizedPaths = [
    '/mail/access',
    '/mail/config/user/',
    '/mail/notifications',
    '/users/get_user_theme_preference_json',
    '/users/post_user_theme_preference'
  ];

  constructor(
    private sessionCleanup: SessionCleanupService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const isPublicFeedbackRequest = this.publicFeedbackPaths.some((path) =>
      req.url.toLowerCase().includes(path.toLowerCase())
    );
    const isNonBlockingUnauthorizedRequest = this.nonBlockingUnauthorizedPaths.some((path) =>
      req.url.toLowerCase().includes(path.toLowerCase())
    );

    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    let authReq = req;

    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 401 &&
          !this.isLoggingOut &&
          !isPublicFeedbackRequest &&
          !isNonBlockingUnauthorizedRequest
        ) {
          this.isLoggingOut = true;
          this.sessionCleanup.promptSessionExpiredAndLogout(5);
          setTimeout(() => {
            this.isLoggingOut = false;
          }, 6000);
        }

        return throwError(() => error);
      })
    );
  }
}
